<template>
	<!--资费信息-->
	<section class="exp-info publish-main">
		<el-form ref="form" :model="form" size="small" :rules="rules">
			<title-area title="资费" hint="必须包含1套的价格，否则无法保存" :margin-left="30">
				<el-form-item prop="zifei">
					<el-radio-group v-model="form.zifei" :disabled="hid">
						<el-radio :label="1">设定价格</el-radio>
						<el-radio :label="2">免费</el-radio>
					</el-radio-group>
				</el-form-item>

				<!--资费编辑区-->
				<div class="box" v-show="form.zifei === 1">
					<el-form-item prop="addLists">
						<div class="btn_box text-right">
							<span class="btn btn_border" id="addOperationBtn" :disabled="hidsubv" @click="addOperation()">添加 +</span>
						</div>
						<section class="add_list clearfix">
							<table class="table table_dashed" v-if="addLists.length>0">
								<tbody>
									<tr v-for="(addList,index) in addLists">
										<td>
											<span class="color_6">单套价格（人民币）：</span>
											<span class="color_9 addList_money" v-if="!costFlag">{{addList.money}} 元</span>
											<input type="text" class="form-control form_control addList_money" v-else :disabled="hidsubv" name="" maxlength="12" :id="'addList_money'+index" v-model="addList.money" />
										</td>
										<td>
											<span class="color_6">服务期限：</span>
											<span class="color_9 addList_timeLimit" v-if="!costFlag">{{addList.timeLimitValue}}</span>
											<input type="hidden" :id="'addList_timeLimit'+index" class="addList_timeLimit" :value="addList.timeLimit" />
											<!--<input type="text" class="form-control width_auto form_control" v-else name="" id="" :value="item.timeLimit" />-->
											<select class="form-control form_control" v-model="addList.timeLimit" :disabled="hidsubv" v-if="costFlag">
												<option value="">请选择服务期限</option>
												<option value="1">1个月</option>
												<option value="12">1年</option>
												<option value="9999">无期限</option>
											</select>
										</td>
										<td>
											<span class="color_6">套数区间：</span>
											<span class="color_9 addList_minNum addList_maxNum" v-if="!costFlag">{{addList.minNum}} ~ {{addList.maxNum}} 套</span>
											<span class="suit" v-else>
										<input type="text" class="form-control form_control addList_minNum" name="" :disabled="hidsubv" :id="'addList_minNum'+index" maxlength="10" value="" v-model="addList.minNum"/>
										~
										<input type="text" class="form-control form_control addList_maxNum" name="" :disabled="hidsubv" :id="'addList_maxNum'+index" maxlength="10" value="" v-model="addList.maxNum"/>
									</span>
										</td>
										<td class="text-center" v-if="!hidsubv && !costFlag">
											<span class="btn_text" @click="costFlag = !costFlag">编辑</span>
										</td>
										<td class="text-center" v-if="!hidsubv">
											<span class="btn_text" @click="costDel(index)">删除</span>
										</td>
										<td :rowspan="addLists.length" v-if="index+1==1 && costFlag && !hidsubv" class="text-center">
											<span class="btn_text h4" @click="saveCharges">保存</span>
										</td>
									</tr>
								</tbody>
							</table>
						</section>
					</el-form-item>
				</div>

			</title-area>

			<title-area title="免费试用" :margin-left="30" :dashed="false" v-show="form.zifei === 1">
				<el-form-item prop="freeType">
					<el-radio-group v-model="form.freeType" :disabled="hidsubv">
						<el-radio :label="0">不支持</el-radio>
						<el-radio :label="1">免费试用一个月</el-radio>
					</el-radio-group>
				</el-form-item>
			</title-area>
		</el-form>
	</section>
</template>

<script>
	import titleArea from './title_area'
	import { MessageBox } from 'element-ui'
	export default {
		name: 'vExpInfo',

		data() {
			var validateFreeType = (rule, value, callback) => {
				if(this.form.zifei === 1 && this.form.freeType === '') {
					callback(new Error('请选择是否支持试用'));
				} else {
					callback();
				}
			};
			var validateAddLists = (rule, value, callback) => {
				if(this.form.zifei == 1 && this.addLists.length == 1 && (Object.keys(this.addLists[0]).length == 0 || this.addLists[0].money == '')) {
					callback(new Error('请填写价格'));
				} else {
					callback();
				}
			};
			return {
				costFlag: true,
				hid: false,
				hidsub: false,
				hidsubv: false,
				addLists: [{}],
				form: {
					zifei: 1,
					freeType: '',
					addLists: [],
				},
				rules: { //表单的验证规则
					zifei: [
						{ required: true, message: '请选择资费类型', trigger: 'change' },
					],
					freeType: [
						{ validator: validateFreeType, trigger: 'change' },
					],
					addLists: [
						{ validator: validateAddLists, trigger: 'change' },
					],
				},
			}
		},

		components: {
			titleArea
		},

		mounted: function() {
			this.$nextTick(function() {
				this.hid = this.$parent.hid;
				this.hidsub = this.$parent.hidsub;
				this.hidsubv = this.$parent.hidsubv;
				var moneyType = this.$parent.tCloudApp.freeType;
				if(moneyType == 2) {
					this.form.zifei = 2;
				} else {
					this.form.freeType = parseInt(this.$parent.tCloudApp.freeType);
					if(null != this.$parent.priceList && this.$parent.priceList.length > 0 && '' != this.$parent.priceList[0])
					{
						this.addLists = this.$parent.priceList;
					}
				}
			})
		},

		methods: {
			verify() { //form表单的校验结果
				var temp = this;
				let flag;
				this.$refs['form'].validate((valid) => {
					if(valid) {
						flag = true;
					} else {
						flag = false;
						return false;
					}
				});
				if(temp.costFlag && temp.form.zifei == 1) {
					var addList_money = $(".addList_money"),
						addList_minNum = $(".addList_minNum"),
						addList_maxNum = $(".addList_maxNum"),
						addList_timeLimit = $(".addList_timeLimit"),
						arrays = [],
						tpList = [];
					var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
					var regx = /^[0-9]*[1-9][0-9]*$/;
					for(var i = 0; i < addList_money.length; i++) {
						temp.addList = {};
						if(!reg.test($(addList_money[i]).val())) {
							$("#addList_money" + i).focus();
							return false;
						}
						if($(addList_timeLimit[i]).val() == '') {
							$("#addList_timeLimit" + i).focus();
							return false;
						}
						if(!regx.test($(addList_minNum[i]).val())) {
							$("#addList_minNum" + i).focus();
							return false;
						}
						if(!regx.test($(addList_maxNum[i]).val())) {
							$("#addList_maxNum" + i).focus();
							return false;
						}
						if($(addList_maxNum[i]).val() - $(addList_minNum[i]).val() < 0) {
							$("#addList_maxNum" + i).focus();
							return false;
						}

						tpList.push($(addList_timeLimit[i]).val() + ":" + $(addList_minNum[i]).val() + ":" + $(addList_maxNum[i]).val());

						temp.addList.money = $(addList_money[i]).val();
						temp.addList.timeLimit = $(addList_timeLimit[i]).val();
						temp.addList.minNum = $(addList_minNum[i]).val();
						temp.addList.maxNum = $(addList_maxNum[i]).val();
						arrays.push(temp.addList);
					}
					temp.validateArray(tpList);
					temp.addLists = [];
					temp.addLists = arrays;
					if(temp.validateArray(tpList)) {
						temp.costFlag = false;
					} else {
						return false;
					}
				}
				
				if(flag) {
					this.form.addLists = this.addLists;
					return {
						flag: flag,
						status: 5,
						form: this.form
					};
				}
			},
			saveverify() { //form表单的校验结果
				var temp = this;
				let flag;
				if(temp.costFlag && temp.form.zifei == 1) {
					
					var addList_money = $(".addList_money"),
						addList_minNum = $(".addList_minNum"),
						addList_maxNum = $(".addList_maxNum"),
						addList_timeLimit = $(".addList_timeLimit"),
						arrays = [],
						tpList = [];
					var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
					var regx = /^[0-9]*[1-9][0-9]*$/;
					for(var i = 0; i < addList_money.length; i++) {
						temp.addList = {};
						if(!reg.test($(addList_money[i]).val())) {
							$("#addList_money" + i).focus();
							return false;
						}
						if($(addList_timeLimit[i]).val() == '') {
							$("#addList_timeLimit" + i).focus();
							return false;
						}
						if(!regx.test($(addList_minNum[i]).val())) {
							$("#addList_minNum" + i).focus();
							return false;
						}
						if(!regx.test($(addList_maxNum[i]).val())) {
							$("#addList_maxNum" + i).focus();
							return false;
						}
						if($(addList_maxNum[i]).val() - $(addList_minNum[i]).val() < 0) {
							$("#addList_maxNum" + i).focus();
							return false;
						}

						tpList.push($(addList_timeLimit[i]).val() + ":" + $(addList_minNum[i]).val() + ":" + $(addList_maxNum[i]).val());

						temp.addList.money = $(addList_money[i]).val();
						temp.addList.timeLimit = $(addList_timeLimit[i]).val();
						temp.addList.minNum = $(addList_minNum[i]).val();
						temp.addList.maxNum = $(addList_maxNum[i]).val();
						arrays.push(temp.addList);
					}
					temp.validateArray(tpList);
					temp.addLists = [];
					temp.addLists = arrays;
					if(temp.validateArray(tpList)) {
						temp.costFlag = false;
					} else {
						return false;
					}
				}
				this.form.addLists = this.addLists;
				return {
					flag: true,
					status: 5,
					form: this.form
				};
			},

			addOperation() {
				var temp = this;
				var newObj = {};
				newObj.money = "";
				newObj.timeLimit = "";
				newObj.minNum = "";
				newObj.maxNum = "";
				temp.addLists.push(newObj);
				temp.costFlag = true;
			},

			costDel(sub) {
				this.addLists.splice(sub, 1);
				if(this.addLists.length <= 0) {
					this.addOperation();
				}
			},

			//保存资费
			saveCharges() {
				var temp = this;
				var addList_money = $(".addList_money"),
					addList_minNum = $(".addList_minNum"),
					addList_maxNum = $(".addList_maxNum"),
					addList_timeLimit = $(".addList_timeLimit"),
					arrays = [],
					tempList = [];
				var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
				var regx = /^[0-9]*[1-9][0-9]*$/;
				for(var i = 0; i < addList_money.length; i++) {
					temp.addList = {};

					if(!regx.test($(addList_money[i]).val())) {
						MessageBox('请输入正确的单套价格！', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							$("#addList_money" + i).focus();
						});
						return false;
					}
					if($(addList_timeLimit[i]).val() == '') {
						MessageBox('请选择服务期限！', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							$("#addList_timeLimit" + i).focus();
						})
						return false;
					}
					if(!regx.test($(addList_minNum[i]).val())) {
						MessageBox('套数上限只允许正整数！', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							$("#addList_minNum" + i).focus();
						})
						return false;
					}
					if(!regx.test($(addList_maxNum[i]).val())) {
						MessageBox('套数下限只允许正整数！', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							$("#addList_maxNum" + i).focus();
						})
						return false;
					}
					if($(addList_maxNum[i]).val() - $(addList_minNum[i]).val() < 0) {
						MessageBox('非法数据，请重新输入！', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							$("#addList_maxNum" + i).focus();
						})
						return false;
					}

					tempList.push($(addList_timeLimit[i]).val() + ":" + $(addList_minNum[i]).val() + ":" + $(addList_maxNum[i]).val());

					if($(addList_timeLimit[i]).val() == 1) {
						temp.addList.timeLimitValue = '1个月'
					} else if($(addList_timeLimit[i]).val() == 12) {
						temp.addList.timeLimitValue = '1年'
					} else if($(addList_timeLimit[i]).val() == 9999) {
						temp.addList.timeLimitValue = '无期限'
					}

					temp.addList.money = $(addList_money[i]).val();
					temp.addList.timeLimit = $(addList_timeLimit[i]).val();
					temp.addList.minNum = $(addList_minNum[i]).val();
					temp.addList.maxNum = $(addList_maxNum[i]).val();
					arrays.push(temp.addList);
				}
				temp.validateArray(tempList);
				temp.addLists = arrays;
				if(temp.validateArray(tempList)) {
					temp.costFlag = false;
				} else {
					return false;
				}
			},

			validateArray(arr) { //数组去重
				var result = [];
				var newArrays1 = [];
				var newArrays12 = [];
				var newArrays9999 = [];
				for(var i = 0; i < arr.length; i++) {
					if(arr[i].split(":")[0] == 1) {
						newArrays1.push(arr[i].split(":")[1] + ":" + arr[i].split(":")[2]);
					} else if(arr[i].split(":")[0] == 12) {
						newArrays12.push(arr[i].split(":")[1] + ":" + arr[i].split(":")[2]);
					} else if(arr[i].split(":")[0] == 9999) {
						newArrays9999.push(arr[i].split(":")[1] + ":" + arr[i].split(":")[2]);
					}

					for(var k = 0; k < newArrays1.length; k++) {
						if(k > 0 && newArrays1[k].split(":")[0] - newArrays1[k - 1].split(":")[1] != 1) {
							MessageBox('请按顺序输入套数，如：1~1;2~10;11~20', '提示', 'warning', {
								confirmButtonText: '确定',
							}).then(() => {

							})
							return false;
						}
					}

					for(var m = 0; m < newArrays12.length; m++) {
						if(m > 0 && newArrays12[m].split(":")[0] - newArrays12[m - 1].split(":")[1] != 1) {
							MessageBox('请按顺序输入套数，如：1~1;2~10;11~20', '提示', 'warning', {
								confirmButtonText: '确定',
							}).then(() => {

							})
							return false;
						}
					}

					for(var n = 0; n < newArrays9999.length; n++) {
						if(n > 0 && newArrays9999[n].split(":")[0] - newArrays9999[n - 1].split(":")[1] != 1) {
							MessageBox('请按顺序输入套数，如：1~1;2~10;11~20', '提示', 'warning', {
								confirmButtonText: '确定',
							}).then(() => {

							})
							return false;
						}
					}

					if(result.indexOf(arr[i]) == -1) {
						result.push(arr[i])
					} else {
						MessageBox('数据重复，请重新输入', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {

						});
						return false;
					}
				}
				return result;
			},
		}
	}
</script>

<style scoped>
	.table_dashed td {
		border: 1px dashed #ccc;
	}
	
	.btn_box {
		margin-bottom: 15px;
	}
	
	.btn_border {
		height: 34px;
		-webkit-border-radius: 2px;
		-moz-border-radius: 2px;
		border-radius: 2px;
	}
	
	.form_control {
		width: 110px;
	}
</style>


// WEBPACK FOOTER //
// exp_info.vue?33a6dd56